import * as React from 'react';
import { DataGrid, ColDef } from '@material-ui/data-grid';
import {useSelector} from "react-redux";
import {RootState} from "../../Store/Reducers";

export default function BillingTableComponent() {

  const {BillingReducer:{billOptionList}} = useSelector((state: RootState) => state);

  const columns: ColDef[] = [
    { field: 'consecutive', headerName: 'Nº de factura', width: 277 },
    { field: 'code', headerName: 'Identificación', width: 277 },
    { field: 'name', headerName: 'Cliente', width: 277 },
    { field: 'payment_date', headerName: 'Fecha de pago', width: 277 }
  ];

  return (
    <div style={{ minHeight: 'calc(100vh - 200px)', width: '100%' }}>
      <DataGrid rows={billOptionList}
                columns={columns}
                pageSize={9} />
    </div>
  );
}
